import { TrackingType } from '@shared/TimeTracker/types';
import { RetroactiveTimeTracking, RetroactiveTrackingActivityType } from './types';
import { format, addMinutes, isValid } from 'date-fns';
import { formatSeconds } from '@shared/TimeTracker/helpers';

export const ACTIVITY_TYPES = {
  PRACTICE: 'Practice',
  CHAT: 'Chat',
  POLL: 'Poll',
  PHONE_CALL: 'Phone Call',
  THERAPY_MEETING: 'Meeting',
  MENTOR_FORM: 'Mentor Form',
  OTHER: 'Other',
};

const TRACKING_TYPES = {
  STOPWATCH: 'Stopwatch',
  RETROACTIVE: 'Retroactive',
};

export const getActivityTypeLabel = (activityType?: RetroactiveTrackingActivityType) => {
  if (!activityType) return '';
  return ACTIVITY_TYPES[activityType] || '';
};

export const getTrackingTypeLabel = (trackingType?: TrackingType) => {
  if (!trackingType) return '';
  return TRACKING_TYPES[trackingType] || '';
};

export const getEndTimeLabel = (startTime?: string | Date | null, duration?: number | null) => {
  if (!startTime || !isValid(new Date(startTime)) || typeof duration !== 'number') return '';
  const end = addMinutes(startTime, Math.round(duration / 60)).toISOString();
  return formatDateTime(end);
};

export const formatDateTime = (value?: string | Date) => {
  const date = new Date(value || '');
  if (!value || !isValid(date)) return '';
  return format(date, 'DD/MM/YY HH:mm');
};

export const formatDuration = (duration?: number) => {
  if (typeof duration !== 'number') return '';
  return formatSeconds(duration);
};

export const csvReportHeaders = [
  { label: 'Activity Type', key: 'activityType' },
  { label: 'Tracking Type', key: 'trackingType' },
  { label: 'Activity', key: 'activityName' },
  { label: 'Comments', key: 'comments' },
  { label: 'Start Time', key: 'startTime' },
  { label: 'Duration (HH:MM:SS)', key: 'duration' },
  { label: 'End Time', key: 'endTime' },
];

export const getCsvReportData = (data: RetroactiveTimeTracking[]) =>
  data.map((item) => {
    const startTime = item.retroactiveStartTime || item.startTime;
    const duration = item.retroactiveDuration || item.duration;
    return {
      activityType: getActivityTypeLabel(item.activityType),
      trackingType: getTrackingTypeLabel(item.trackingType),
      activityName: item.activityName,
      comments: item.comments,
      startTime: formatDateTime(startTime),
      duration: formatDuration(duration),
      endTime: getEndTimeLabel(startTime, duration),
    };
  });
